import React from "react";

const QuoteCard = () => (
  <aside className="quote-strip" aria-label="Personal motto">
    <div className="site-container quote-inner">
      <p>“I don’t deploy to impress, I deploy to express.”</p>
      <span>— Meraj</span>
    </div>
  </aside>
);

export default QuoteCard;
